import * as React from "react";

function SvgAzureFunctions(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 65 61"
      fill="#fff"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <use xlinkHref="#AzureFunctions_svg__a" x={0.5} y={0.5} />
      <symbol id="AzureFunctions_svg__a" overflow="visible">
        <g stroke="none" fillRule="nonzero">
          <path
            d="M63.597 29.89c.585-.585.487-1.7 0-2.307l-3.087-3.087-13.8-13.386c-.585-.585-1.495-.585-2.2 0-.585.585-.812 1.7 0 2.307l14.5 14.198c.585.585.585 1.7 0 2.307L44.2 44.608c-.585.585-.585 1.7 0 2.307.585.585 1.7.487 2.2 0l13.8-13.68zm-63.194 0c-.585-.585-.487-1.7 0-2.307l3.087-3.087 13.8-13.386c.585-.585 1.495-.585 2.2 0 .585.585.812 1.7 0 2.307l-14.2 14.2c-.585.585-.585 1.7 0 2.307l14.5 14.686c.585.585.585 1.7 0 2.307-.585.585-1.7.487-2.2 0L3.49 33.44z"
            fill="#3999c6"
          />
          <path
            d="M34.583 19.915L47.58 0H28.085L17.59 29.6l12.8.097-10.007 29.307L48 19.918z"
            fill="#fcd116"
          />
          <path
            d="M48.002 19.915h-13.42L47.58 0H37.377L26.59 24.594l12.8.097-19.007 34.3z"
            fill="#ff8c00"
            opacity={0.3}
          />
        </g>
      </symbol>
    </svg>
  );
}

export default React.forwardRef(SvgAzureFunctions);
